/**
 * Generated runtime TestId mirror for frontend/src/features/certification/components/WizardStepLaunch.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const WizardStepLaunchTestIds = {
  btnFinish: "btn-finish",
  btnLaunchBack: "btn-launch-back",
  btnLaunchStage: "btn-launch-stage",
  btnLaunchStageActivate: "btn-launch-stage-activate",
  launchGoToCampaign: "launch-go-to-campaign",
  launchNoCampaignPermission: "launch-no-campaign-permission",
  launchOpenCampaignWarning: "launch-open-campaign-warning",
  launchPartialFailure: "launch-partial-failure",
  launchScopeCount: "launch-scope-count",
  launchScopeDisclaimer: "launch-scope-disclaimer",
  launchSection: "launch-section",
  launchStageError: "launch-stage-error",
  launchSummary: "launch-summary",
  wizardLaunchAlreadySavedNote: "wizard-launch-already-saved-note",
  wizardPolicySavedBanner: "wizard-policy-saved-banner"
} as const;
